<template>
    <div id="app" v-bind:class="{mobile:isMobile,desktop:!isMobile,forcedbasket:forcedBasket&&showBasket,header:headerConfig!='none'}" v-bind:style="{'background-image':bgImage}">
        <transition name="fade" mode="out-in">
            <div class="init" v-if="initialising&&systemError==''">
                <div>
                    <i class="far fa-circle-notch fa-spin"></i>
                    <div style="margin-top:20px;font-size:20px;width:100%;" v-if="klarnaCallbackFlow"><b>Thank you for paying with Klarna.</b><br><br>Let us finish your transaction for you.</div>
                </div>
            </div>
        </transition>
        <transition name="fade" mode="out-in">
            <div class="dialog" v-if="!initialising&&klarnaCallbackFlow">
                <div class="innerdialog klarna postpayment">
                    <div class="status" v-bind:class="{success:prepopulatedKlarna.Data.Status,fail:!prepopulatedKlarna.Data.Status}">Payment <span v-if="prepopulatedKlarna.Data.Status">success</span><span v-else>fail</span>!</div>
                    <div class="overflower">
                        <div class="thankyou" v-if="prepopulatedKlarna.Data.Status&&prepopulatedKlarna.Data.ThankYouMessage==''">Thank you for paying with Klarna.</div>
                        <div class="thankyou" v-if="!prepopulatedKlarna.Data.Status">Unfortunately there was a problem with the payment.</div>
                        <div class="thankyou" v-if="entry.class=='course'&&prepopulatedKlarna.Data.Status" v-for="entry in prepopulatedKlarna.Entries">Your purchase of the course <b v-html="entry.description"></b> for <b><span class="currency">{{parameters.Currency}}</span>{{entry.price.toFixed(2)}}</b> is complete. We have sent you an email with the details.</div>
                        <div class="thankyou" v-if="prepopulatedKlarna.Entries[0].class=='giftcard'&&prepopulatedKlarna.Data.Status">Your giftcard(s) will be sent out shortly.</div>
                        <div class="thankyou" v-if="prepopulatedKlarna.Data.ThankYouMessage!=''" v-html="prepopulatedKlarna.Data.ThankYouMessage"></div>
                        <div class="details" v-show="((prepopulatedKlarna.isCourse==false)||(prepopulatedKlarna.Data.Status==false))&&(prepopulatedKlarna.Entries[0].class!='product')">
                            <div class="entry" v-bind:class="entry.class" v-for="entry in prepopulatedKlarna.Entries" >
                                <div v-if="entry.class=='error'" style="color:red;"><b v-html="entry.Message"></b></div>
                                <div v-if="entry.class=='giftcard'"><b v-html="entry.itemsdescription"></b></div>
                                <div v-if="entry.class=='giftcard'" style="margin-top:10px;">
                                    <div>This giftcard is for <span v-if="entry.ToName!=''"><b>{{entry.ToName}}</b></span><span v-else>you</span>.</div>
                                </div>
                                <div v-if="entry.class=='service'" style="display:flex;justify-content:space-between;"><b v-html="entry.servicedescription"></b><b><span class="currency">{{parameters.Currency}}</span>{{entry.servicePrice.toFixed(2)}}</b></div>
                                <!-- <div v-if="entry.class=='course'" style="display:flex;justify-content:space-between;"><b v-html="entry.description"></b><b><span class="currency">{{parameters.Currency}}</span>{{entry.price.toFixed(2)}}</b></div> -->
                            </div>
                        </div>
                    </div>
                    <div class="continue">
                        <button v-on:click="continueToBP">Continue</button>
                    </div>
                </div>
            </div>
        </transition>
        <transition name="fade" mode="out-in">
            <div class="loader" v-if="loading">
                <i class="far fa-circle-notch fa-spin"></i>
            </div>
        </transition>
        <transition name="fade" mode="out-in">
            <div id="missingdetails" v-if="showMissingDetails">
                <div class="panel">
                    <div class="title"><span>Missing details</span></div>
                    <div class="content">
                        <div class="lowerinfo">Please provide the missing details to access your account.</div>
                        <div class="error" v-if="missingDetailsError">{{missingDetailsError}}</div>
                        <input placeholder="Password" v-model="missingdetails.Password" type="password"></input>
                        <input placeholder="Mobile" v-model="missingdetails.Mobile"></input>
                        <div class="consent">
                            <div class="info">We would love to send you occasional salon news and promotions. To join our mailing list, simply tick the relevent boxes below. You can unsubscribe at any time from your profile settings.</div>
                            <div class="left">
                                <label>Email</label><dkswitch v-model="missingdetails.EmailOptout"></dkswitch>
                            </div>
                            <div class="right">
                                <label>SMS</label><dkswitch v-model="missingdetails.SmsOptout"></dkswitch>
                            </div>
                        </div>
                        <div class="controls">
                            <button class="submit" v-on:click="missingdetailssubmit()">SUBMIT</button>
                        </div>
                    </div>
                </div>
            </div>
        </transition>
        <transition name="fade" mode="out-in">
            <div class="init error" v-if="initialising&&systemError!=''">
                <div class="warning">
                    <div class="triangle">
                        <i class="fas fa-exclamation-triangle"></i>
                    </div>
                    <div class="text">{{systemError}}</div>
                </div>
            </div>
        </transition>
        <div id="nav" v-bind:class="{menuopen:menuOpen}" v-if="!initialising&&systemError==''">
            <!-- <div id="logo" v-bind:style="{'background-image':logoImage}"></div> -->
            <a id="logo" v-bind:href="parameters.websitelink" target="_blank"><img v-bind:src="logoImage" /></a>
            <a id="websitelink" v-bind:href="parameters.websitelink" target="_blank" v-if="parameters.websitelink!=''">Home</a>
            <router-link to="/contact" v-show="showNavLinks" v-if="showNavEntry('contact')">Contact</router-link>
            <router-link to="/courses" v-show="showNavLinks&&chosenSalon.ShowCourses" v-if="showNavEntry('courses')">Courses</router-link>
            <router-link to="/subscriptions" v-show="showNavLinks&&chosenSalon.ShowSubscriptions" v-if="showNavEntry('subscriptions')">Subscriptions</router-link>
            <router-link to="/giftcards" v-show="showNavLinks&&parameters.OnlineGCSaleType!=0" v-if="showNavEntry('giftcards')">Gift cards</router-link>
            <router-link to="/reviews" v-show="showNavLinks&&parameters.EnableReviews" v-if="showNavEntry('reviews')">Reviews</router-link>
            <router-link to="/shop" v-show="showNavLinks&&parameters.SellProductsOnline" v-if="showNavEntry('shop')">Shop</router-link>
            <router-link to="/book" v-show="showNavLinks&&parameters.Showbook" v-if="showNavEntry('book')">{{chosenSalon.BookLabel}}</router-link>
            <!-- <router-link to="/book" v-show="showNavLinks">Book2</router-link> -->
            <button v-bind:class="{basketbutton:true,oncheckout:onCheckout,on:showBasket,bounce:bounceBasket}" v-on:click="showBasket=!showBasket"  v-if="showNavEntry('shop')">
                <i class="fas fa-shopping-basket"></i>
                <i class="fal fa-times"></i>
                <div class="bubble" v-if="!onCheckout">{{basketItemCount}}</div>
            </button>
            <router-link to="/user" v-bind:class="{user:true,large:isAuthorised}" v-show="showNavLinks">
                <i class="fas fa-user-circle" v-if="!isAuthorised||(isAuthorised&&userDetails.Clientimage=='')"></i>
                <div v-bind:style="{'background-image':'url('+userDetails.Clientimage+')'}" v-else></div>
            </router-link>
            <button class="fnb" v-on:click="toggleMenu()" v-show="!showNavLinks">
                <i class="fas fa-bars" v-show="!menuOpen"></i>
                <i class="fas fa-times" v-show="menuOpen"></i>
            </button>
        </div>
        <div id="content" v-bind:class="contentClasses" v-if="!initialising&&systemError==''">
            <router-view :key="$route.fullPath"/>
            <basket v-on:resetservices="switchToServices()" v-on:gotocheckout="goToCheckout()" v-if="showBasket"></basket>
        </div>
        <div id="smallnav" v-bind:class="{menuopen:menuOpen}" v-if="!initialising&&systemError==''">
            <router-link to="/contact" v-on:click.native="toggleMenu()" v-if="showNavEntry('contact')">Contact</router-link>
            <router-link to="/courses" v-on:click.native="toggleMenu()" v-if="chosenSalon.ShowCourses&&showNavEntry('courses')">Courses</router-link>
            <router-link to="/subscriptions" v-on:click.native="toggleMenu()" v-if="chosenSalon.ShowSubscriptions&&showNavEntry('subscriptions')">Subscriptions</router-link>
            <router-link to="/giftcards" v-on:click.native="toggleMenu()" v-if="parameters.OnlineGCSaleType!=0&&showNavEntry('giftcards')">Gift cards</router-link>
            <router-link to="/reviews" v-on:click.native="toggleMenu()" v-if="parameters.EnableReviews&&showNavEntry('reviews')">Reviews</router-link>
            <router-link to="/shop" v-on:click.native="toggleMenu()" v-if="parameters.SellProductsOnline&&showNavEntry('shop')">Shop</router-link>
            <router-link to="/book" v-on:click.native="toggleMenu()" v-if="parameters.Showbook&&showNavEntry('book')">{{chosenSalon.BookLabel}}</router-link>
            <router-link to="/user" class="user" v-on:click.native="toggleMenu()">
                <!-- <span v-if="!isAuthorised">Login</span> -->
                <i class="fas fa-user"></i>
            </router-link>
            <!-- <a id="websitelink" v-bind:href="parameters.websitelink" target="_blank" v-on:click="toggleMenu()" v-if="parameters.websitelink!=''"><i class="fas fa-globe"></i></a> -->
        </div>
        <div id="debugsection" style="position: fixed;bottom: 0;left: 0;background-color: rgba(0,0,0,0.75);padding: 10px;" v-if="showDebug">
            <button v-on:click="DEBUG_toggleService">TOGGLE SERVICES FIRST</button>
        </div>
        <transition name="fade" mode="out-in">
            <div class="cookieconsent" v-show="cookieConsentVisible">
                <div class="left">
                    <div class="title">Cookies</div>
                    <div class="subtitle">We use cookies to ensure you get the best experience possible.</div>
                </div>
                <div class="footer">
                    <button class="moreinfo" v-on:click="getCookieInfo()">More info</button>
                    <button class="acceptcookies" v-on:click="acceptCookies()">Ok</button>
                </div>
            </div>
        </transition>
        <transition name="fade" mode="out-in">
            <div class="notification" v-if="notification!=null" v-bind:style="notification.style">
                <div class="message" v-html="notification.message"></div>
                <button v-if="notification.forgotpwd" v-on:click="redirectToForgotPassword" style="margin-right:10px;">SUBMIT</button>
                <button v-if="notification.forgotpwd" v-on:click="closeNotification">CANCEL</button>
                <button v-if="notification.timeout==0&&!notification.forgotpwd" v-on:click="closeNotification">{{notification.buttonLabel}}</button>
            </div>
        </transition>
    </div>
</template>


<script>
// @ is an alias to /src
// @ is an alias to /src
import { mapGetters, mapActions } from "vuex";
import moment from "moment";
import lodash from "lodash/lodash.min.js";
import Basket from '@/components/Basket.vue';
import dkswitch from '@/components/Switch';


    export default {
        name: 'app',
        components: {
            Basket,
            dkswitch
        },
        data () {
            return {
                showDebug: false,
                windowWidth: 0,
                menuOpen: false,
                showBasket: false,
                missingdetails: {
                    Password:   "",
                    Mobile:     "",
                    Gender: "0",
                    EmailOptout:false,
                    SmsOptout:  false
                }
            }
        },
        computed: lodash.assign(
            mapGetters({
                bgImage: "get_bgimage",
                logoImage: "get_logoimage",
                parameters: "get_parameters",
                headerConfig: "get_headerconfig",
                user: "get_user",
                userDetails: "get_userdetails",
                initialising: "get_initialising",
                loading: "get_loading",
                systemError: "get_systemerror",
                basket: "get_basket",
                isMobile: "get_ismobile",
                isAuthorised: "get_isauthorised",
                showMissingDetails: "get_showmissingdetails",
                missingDetailsError: "get_missingdetailserror",
                cookieConsentVisible: 'get_cookieconsent',
                notification: "get_notification",
                EventBus: "get_eventbus",
                bounceBasket: "get_bouncebasket",
                klarnaCallbackFlow: "get_klarnacallbackflow",
                prepopulatedKlarna: "get_prepopulatedklarna",
                chosenSalon: "get_selectedsalon",
            }),
            {
                contentClasses () {
                    var obj = {menuopen:this.menuOpen};
                    obj[this.$route.name] = true;
                    return obj;
                },
                showNavLinks () {
                    return this.windowWidth > 870;
                },
                basketItemCount () {
                    var totalProducts = 0;
                    this.basket.map( (a) => { totalProducts += a.type!= 2 ? a.data.quantity : 0; });
                    return totalProducts;
                },
                onCheckout () {
                    return this.$route.name == "checkout";
                },
                forcedBasket () {
                    return this.$route.name == "book" || this.$route.name == "giftcards";
                }
            }
        ),
        watch: {
            notification () {
                var _this = this;
                if(this.notification == null) return;
                if(this.notification.timeout == 0) return;
                setTimeout( () => {
                    _this.$store.dispatch("showNotification",null);
                },_this.notification.timeout);
            }
        },
        methods: _.assign(mapActions(['loadParameters','sniffPlatformDetails']), {
            continueToBP () {
                this.$store.commit("set_klarnacallbackflow",false);
                this.$store.dispatch("erasePrepopulatedData",5);
            },
            showNavEntry (entry) {
                if(this.headerConfig == "all") return true;
                return this.headerConfig.indexOf(entry) > -1;
            },
            getCookieInfo () {
                var win = window.open("https://saloniq.com/privacy-policy/", "_blank");
                win.focus();
            },
            acceptCookies () {
                this.$store.dispatch("saveCookieConsent");
            },
            DEBUG_toggleService() {
                this.$store.dispatch("DEBUG_toggleServiceFirst",{});
            },
            resize () {
                this.windowWidth = window.innerWidth;
                this.menuOpen = false;
                this.$store.dispatch("onResize",this.windowWidth);
            },
            toggleMenu () {
                this.menuOpen = !this.menuOpen;
            },
            switchToServices () {
                this.$router.replace("book");
            },
            goToCheckout () {
                this.showBasket = false;
                this.$router.replace(this.isAuthorised ? "checkout" : "user");
            },
            missingdetailssubmit () {
                if (this.missingdetails.Mobile == "" || this.missingdetails.Mobile.length < 10 || /^\d+$/.test(this.missingdetails.Mobile) == false ) {
                    this.$store.dispatch("showNotification",{message:"Mobile number empty or incorrect.",style:{'background-color':"red",color:"white"},timeout:2000});
                    return;
                }
                this.$store.dispatch("setMissingDetails",{user:this.missingdetails});
            },
            closeNotification  () {
                if(typeof this.notification.callback == "function") this.notification.callback();
                this.$store.dispatch("showNotification",null);
            },
            redirectToForgotPassword () {
                this.closeNotification();
                this.EventBus.$emit("changeToForgotPassword");
            },
            removeHTMLtags (str) {
                return str.replace(/(<([^>]+)>)/gi, "");
            }
        }),
        created () {
            window["BPApp"] = this;
            var urlParams = {};
            var ac = window.location.search.replace("?", "");
            var params = {}; if (location.search) for (var parts = location.search.substring(1).split("&"), i = 0; i < parts.length; i++) { var nv = parts[i].split("="); nv[0] && (params[nv[0]] = nv[1] || !0) } urlParams = params;
            if (Object.keys(urlParams)[0] === ac) urlParams = { id: ac };
            this.$store.dispatch("setURLParams", urlParams);
            this.$store.dispatch("getUserIDCookie");
            this.$store.dispatch("getCookieConsentCookie");
            this.sniffPlatformDetails();
            this.EventBus.$on("showBasket",(on)=>{this.showBasket=on});
        },
        mounted () {
            window.addEventListener("resize",this.resize);
            this.resize();
            //console.log(this.$store.state.settings.user.id);
            if(typeof this.$store.state.settings.urlParams.salonid != "undefined") this.$nextTick( () => { this.loadParameters(); });
        }
    }


</script>


<style lang="scss">
    @import "scss/_hub-sass-common-functions.scss";

    .react-code-input-container {
        font-family: inherit!important;
        & .react-code-input {
            font-family: inherit!important;
            & input {
                border-radius: 0!important;
                font-family: inherit!important;
            }
        }
    }

    #MazPhoneNumberInput {
        box-sizing: border-box;
        width:calc(100% - 20px);
        margin:10px 10px 0 10px;
        font-family: 'Roboto', Helvetica, Arial, sans-serif !important;
        & .country-selector__input, & .input-tel__input {
            font-size:1.2em;
            border-radius: 0!important;
            box-shadow: none!important;
            border: 1px solid rgba(0, 0, 0, 0.25)!important;
            font-family: 'Roboto', Helvetica, Arial, sans-serif !important;
        }
        & .vue-recycle-scroller__item-view {
            & button {
                color:black;
            }
        }
        & * {
            border-color:grey!important;
        }
        & label {
            color:grey!important;
        }
    }

    .fade-enter-active, .fade-leave-active {
      transition: opacity .5s;
      position:absolute;
      width:100%;
    }
    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
      opacity: 0;
    }

    @-webkit-keyframes bounceIn {
    0%, 25%, 50%, 75%, 100% {
    -webkit-transition-timing-function: cubic-bezier(0.215, 0.610, 0.355, 1.000);
    transition-timing-function: cubic-bezier(0.215, 0.610, 0.355, 1.000);
    }
    0% {
    -webkit-transform: scale3d(1, 1, 1);
    transform: scale3d(1, 1, 1);
    }
    25% {
    -webkit-transform: scale3d(1.5, 1.5, 1.5);
    transform: scale3d(1.5, 1.5, 1.5);
    }
    50% {
        -webkit-transform: scale3d(1, 1, 1);
        transform: scale3d(1, 1, 1);
    }
    75% {
    -webkit-transform: scale3d(1.2, 1.2, 1.2);
    transform: scale3d(1.2, 1.2, 1.2);
    }
    100% {
    -webkit-transform: scale3d(1, 1, 1);
    transform: scale3d(1, 1, 1);
    }
    }
    @keyframes bounceOut {
        0%, 100% {
        -webkit-transition-timing-function: cubic-bezier(0.215, 0.610, 0.355, 1.000);
        transition-timing-function: cubic-bezier(0.215, 0.610, 0.355, 1.000);
        }
        0% {
            -webkit-transform: scale3d(1, 1 1);
            transform: scale3d(1, 1, 1);
        }
        100% {
            -webkit-transform: scale3d(1, 1, 1);
            transform: scale3d(1, 1, 1);
        }
    }

    .loadingindicatorwrapper {
        width: 100%;
        height: 200px;
        font-size:100px;
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: rgba(255,255,255,0.5);
        color:black;
        pointer-events: auto;
        &.medium {
            font-size: 50px;
        }
        &.absolute {
            position: absolute;
            z-index: 1;
            top:0;
            bottom:0;
            right:0;
            left:0;
            height:auto;
        }
        &.dark {
            background-color: rgba(0,0,0,0.5);
            color:white;
        }
    }

    html,body {
        padding:0;
        border:0;
        margin:0;
        //background-color: $ghost-white;
    }
    #app {
      font-family: 'Roboto', Helvetica, Arial, sans-serif;
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
      text-align: center;
      color: $textColour;
      font-size:1em;
      background-position: center center;
      background-repeat: no-repeat;
      background-size: contain;
      & .init, & .loader {
          position: fixed;
          top:0;
          bottom:0;
          right:0;
          left:0;
          background-color: white;
          color:black;
          font-size:100px;
          z-index:20;
          display: flex;
          justify-content: center;
          align-items: center;
          flex-wrap: wrap;
          &.error {
              & .warning {
                  display: block;
                  & .triangle {
                      color: red;
                  }
                  & .text {
                      font-size:0.5em!important;
                  }
              }
          }
      }
      & .klarna {
          position: fixed;
          display: flex;
          flex-direction: column;
          background-color: white;
          color:black;
          z-index:10;
          border-radius: 20px;
          & .status {
              margin:20px;
              padding:20px;
              font-size: 1.5em;
              font-weight: bold;
              border-radius: 10px;
              &.success {
                  background-color: lawngreen;
              }
              &.fail {
                  background-color: red;
              }
          }
          & .thankyou {
               margin:0 20px 20px 20px;
               font-size: 20px;
          }
          & .details {
              width:calc(100% - 0px);
              padding:0 20px;
              box-sizing: border-box;
              & .entry {
                  width:100%;
                  max-width:500px;
                  border-radius: 10px;
                  background-color: rgba(0,0,0,0.1);
                  padding:20px;
                  margin:5px auto;
                  box-sizing: border-box;
              }
          }
          & .continue {
              margin:20px;
              & button {
                  font-size:20px;
                  padding:10px;
              }
          }
      }
      & .loader {
          background-color: rgba(0,0,0,0.5);
          color:white;
          font-size: 11;
      }
    }
    #nav {
        display:none;
        justify-content: flex-end;
        position:fixed;
        top:0;
        left:0;
        right:0;
        background-color: rgba(255,255,255,0.9);
        background: linear-gradient(to bottom, rgba(255,255,255,1) 0%,rgba(255,255,255,0.95) 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
        transition: all 0.5s ease;
        z-index: 1;
        height:70px;
        box-shadow: 0 0px 10px rgba(0,0,0,0.5);
        & a {
            color: $textColour;
            padding:25px;
            font-size:1.2em;
            text-decoration: none;
            display: inline-block;
            position: relative;
            &:hover {
                //background-color: #EEEEEE;
            }
            &.router-link-exact-active {
                //background-color: $panelTitleBackgroundColour;
                color: $panelTitleBackgroundColour;//$panelTitleTextColour;
                font-weight: bold;
                // &::after {
                //     content:"";
                //     position: absolute;
                //     bottom:0;
                //     right:0;
                //     left:0;
                //     height:3px;
                //     background-color: $panelTitleBackgroundColour;
                // }
            }
            &.user {
                //width:51px;
                display: flex;
                justify-content: center;
                align-items: center;
                & .img {
                    width:40px;
                    height:40px;
                    background-repeat: no-repeat;
                    background-size: cover;
                    background-position: center;
                }
                & div {
                    width: 40px;
                    height: 40px;
                    background-position: center;
                    background-repeat: no-repeat;
                    background-size: cover;
                    border-radius: 50%;
                    border: 1px solid rgba(0,0,0,0.25);
                }

            }
        }
        & .fnb {
            font-size: 1.75em;
            background-color: transparent;
            color:black;
            border: none;
            width: 47px;
            height: 47px;
            cursor:pointer;
            box-shadow: none;
        }
        & .basketbutton {
            background-color: transparent;
            color: $textColour;
            box-shadow: none;
            font-size: 1.2em;
            padding:11px;
            width: 73px;
            border-radius: 0;
            position: relative;
            animation: bounceOut 0.5s 0s both;
            & .fa-shopping-basket {
                display: inline-block;
            }
            & .fa-times {
                display: none;
            }
            & .bubble {
                position: absolute;
                top:8px;
                right:8px;
                border-radius: 50%;
                width:24px;
                height:24px;
                background-color: $panelTitleTextColour;
                color: $textColour;
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: 14px;
                font-weight: bold;
            }
            &.bounce {
                animation: bounceIn 1s 0s both;
                animation-direction: normal;
            }
            &.on {
                & .fa-shopping-basket {
                    display: none;
                }
                & .fa-times {
                    display: inline-block;
                }
                //color: $panelTitleBackgroundColour;
                //background-color: $newPanelColour;
                & .bubble {
                    display: none;
                    //background-color: $textColour;
                    //color: $panelTitleTextColour;
                }
            }
            &.oncheckout {
                //background-color: $panelTitleBackgroundColour;
                //color: $panelTitleTextColour;
                &::after {
                    content:"";
                    position: absolute;
                    bottom:0;
                    right:0;
                    left:0;
                    height:3px;
                    background-color: $panelTitleBackgroundColour;
                }
            }

        }
        & .user {
             font-size: 45px;
        }
        &.menuopen {
            transform: translateX(-200px);
        }
    }
    #content {
        height:100vh;
        overflow: hidden;
        overflow-y: auto;
        transition: all 0.5s ease;
        //display: flex;
        & .page {
            margin-top:0;
            height:calc(100% - 0);
            width:100%;
        }
        &.menuopen {
            transform: translateX(-200px);
        }
    }
    #smallnav {
        position: fixed;
        top:0;
        right:0;
        height:100vh;
        width:200px;
        background-color: $newPanelColour;
        transform: translateX(200px);
        transition: all 0.5s ease;
        &.menuopen {
            transform: translateX(0px);
        }
        & a {
            width: 100%;
            display: block;
            text-decoration: none;
            font-size: 1em;
            color: black;
            font-weight: bold;
            padding: 10px;
            text-align: center;
            &:hover, &.router-link-exact-active {
                background-color: white;
                color: rgb(50,50,50);
            }
        }
    }
    #logo {
        background-position: center center;
        background-repeat: no-repeat;
        background-size: contain;
        margin-left:20px;
        margin-right:auto;
        max-height:70px;
        padding:0!important;
        & img {
            height: auto;
            width: auto;
            max-height: 70px;
            max-width: 400px;
        }
    }
    #missingdetails {
        position: fixed;
        top: 0;
        bottom: 0;
        right: 0;
        left: 0;
        z-index: 10;
        background-color: white;
        // background-color: transparentize($panelTitleBackgroundColour,0.05);
        // color: $panelTitleTextColour;
        display: flex;
        justify-content: center;
        & .panel {
            background-color: transparent;
            width:50%;
            min-width: 300px;
            max-width: 500px;
            margin: 20px 0;
            //color: $panelTitleTextColour;
            & .title {
                padding:10px 10px 0 10px;
                font-size: 1.2em;
                //background-color: $panelTitleBackgroundColour;
                //color: $panelTitleTextColour;
            }
            & .content {
                padding:10px;
                & input {
                    box-sizing: border-box;
                    width:calc(100% - 20px);
                    margin:10px 10px 0 10px;
                    font-size:1.2em;
                    padding:10px;
                }
                & .controls {
                    padding:10px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    & .submit {
                        font-size:1.2em;
                        padding:10px;
                        white-space: nowrap;
                    }
                }
                & .error {
                    margin: 10px;
                    background-color: red;
                    color: white;
                    padding: 10px;
                }
                & .fb-signin-button {
                    margin:10px;
                }
                & .consent {
                    margin:20px 10px 10px 10px;
                    padding:10px;
                    //background-color:$panelTitleBackgroundColour;
                    //color:$panelTitleTextColour;
                    display: flex;
                    flex-wrap: wrap;
                    & .info {
                        width:100%;
                        margin-bottom:10px;
                        color:inherit;
                        text-align: left;
                    }
                    & .left, & .right {
                        @include flex();
                        justify-content: center;
                        align-items: center;
                        width: 50%;
                        & label {
                            margin-right:10px;
                            color:inherit;
                        }
                    }
                }
            }
        }
    }

    #app {
        &.forcedbasket {
            & #content {
                & .page {
                    //width:calc(100% - 320px);
                }
                & .basket {
                    // top:0;
                    // bottom:0;
                    // margin-bottom:0;
                    // & .basket2 {
                    //     box-shadow:none;
                    // }
                }
            }
        }
        &.header {
            & #nav {
                display: flex;
            }
            & #content {
                & .page {
                    margin-top:70px;
                    height:calc(100% - 70px);
                }
            }
        }
    }

    input, select, textarea {
        //background-color: $newPanelColour;
        border:1px solid rgba(0,0,0,0.25);
        font-family: inherit;
        &.light {
            //background-color: $ghost-white;
        }
    }

    button, input, select, textarea {
        outline:none;
        font-family: 'Roboto', Helvetica, Arial, sans-serif;
        //border:0;
        &.disabled {
            opacity:0.5;
            pointer-events: none;
        }
        &.error {
            background-color: #ff9999;
        }
    }

    button {
        font-size: 1em;
        border:0;
        //box-shadow: 0 2px 2px rgba(0,0,0,0.5);
        transition: all 0.1s ease;
        background-color: var(--button-color);
        color: $buttonTextColour;
        border-radius: 2px;
        cursor:pointer;
        user-select: none;
        &:hover {
            background-color: var(--button-color-light);
            //background-color: lighten($buttonBackgroundColour, 10);
            //box-shadow: none!important;
        }
    }

    select {
        outline: none;
    }

    .price {
        font-size:1.2rem;
        font-weight:bold;
    }

    .currency {
        font-size:0.75em;
    }

    .dialog {
        position: fixed;
        top:0;
        bottom:0;
        left:0;
        right:0;
        z-index: 10;
        background-color: rgba(0,0,0,0.25);
        & .innerdialog {
            position: absolute;
            top:20%;
            //min-height: calc(60% - 0px);
            max-height: calc(60% - 0px);
            //bottom:20%;
            left:25%;
            right:25%;
            z-index: 20;
            box-shadow: 0 25px 50px rgba(0,0,0,0.5);
            //background-color: white;
            display: flex;
            background-repeat: no-repeat;
            background-size: cover;
            background-position: center;
            border-radius: 10px;
            & > .inner {
                display: flex;
                overflow: hidden;
                overflow-y: auto;
                border-radius: 10px;
                width: 100%;
                background-color: rgba(255,255,255,1);
                & .imagewrapper {
                    width: 50%;
                    display: flex;
                    flex-direction: column;
                    & .currentimage {
                        background-position: center;
                        background-repeat: no-repeat;
                        background-size: contain;
                        height:100%;
                        touch-action:pinch-zoom;
                    }
                    & .images {
                        background-color: rgba(0,0,0,0.1);
                        height:100px;
                        min-height:100px;
                        flex:0 0 auto;
                        display: flex;
                        overflow: hidden;
                        overflow-x: auto;
                        & .image {
                            flex:0 0 auto;
                            margin:10px;
                            height:80px;
                            width:80px;
                            background-position: center;
                            background-repeat: no-repeat;
                            background-size: contain;
                        }
                    }
                }
                & .rightside {
                    width: 50%;
                    flex:0 0 auto;
                    display:flex;
                    flex-direction: column;
                    //box-shadow: 0 0 20px rgba(0,0,0,0.5);
                    //background-color: rgba(0,0,0,0.1);
                    overflow: hidden;
                    overflow-y: auto;
                    z-index: 1;
                    & .name {
                        padding:10px;
                        font-size: 1.2em;
                        font-weight: bold;

                        text-align: left;
                        border-bottom:1px solid rgba(0,0,0,0.1);
                    }
                    & .description {
                        border-bottom:1px solid rgba(0,0,0,0.1);
                        padding:10px;
                        text-align: left;
                        height:auto;
                        max-height: 200px;
                        overflow-y: auto;
                        flex:0 0 auto;
                    }
                    & .category {
                        text-align: left;
                        padding: 10px;
                        & .filter {
                            padding: 2px 5px;
                            background-color: rgba(0,0,0,0.1);
                            border-radius: 5px;
                            margin-right: 5px;
                        }
                    }
                    & .spacer {
                        height: 100%;
                        border-bottom:1px solid rgba(0,0,0,0.1);
                    }
                    & .controls {
                        display: flex;
                        justify-content: flex-end;
                        align-items: center;
                        padding: 15px;
                        & .quantity {
                            padding:10px;
                            text-align: right;
                            & select {
                                padding:5px;
                                width: 50px;
                                border: 1px solid rgba(0,0,0,0.25);
                            }
                        }
                        & .addbutton {
                            text-align: right;
                            & button {
                                border: none;
                                padding: 15px;
                                font-size: 1em;
                                //font-weight: bold;
                                border-radius: 5px;
                                background-color: $buttonBackgroundColour;
                                //box-shadow: 0 4px 8px rgba(0,0,0,0.5);
                                cursor:pointer;
                                transition:all 0.1s ease;
                                width:100%;
                                max-width: 250px;
                                &:hover {
                                    box-shadow: none;
                                }
                                &.disabled {
                                    opacity: 0.5;
                                    pointer-events: none;
                                }

                            }
                        }
                    }
                }
            }
            & .closebutton {
                position: absolute;
                font-size: 50px;
                color:white;
                cursor: pointer;
                width:50px;
                height:50px;
                display: flex;
                justify-content: center;
                align-items: center;
                right: -50px;
                top: -50px;
                text-shadow: 0 0 30px black;
                & i {
                    transition: all 0.5s ease;
                }
                &:hover {
                    & i {
                        transform: scale(1.2);
                    }
                }
            }
            &.postpayment {
                position: fixed;
                display: flex;
                flex-direction: column;
                background-color: white;
                color:black;
                z-index:10;
                border-radius: 20px;
                & .overflower {
                    height: 100%;
                    overflow: hidden;
                    overflow-y: auto;
                }
                & .status {
                    margin:20px;
                    padding:20px;
                    font-size: 1.5em;
                    font-weight: bold;
                    border-radius: 10px;
                    &.success {
                        background-color: lawngreen;
                    }
                    &.fail {
                        background-color: red;
                    }
                }
                & .thankyou {
                     margin:0 20px 20px 20px;
                     font-size: 20px;
                }
                & .details {
                    width:calc(100% - 0px);
                    padding:0 20px;
                    box-sizing: border-box;
                    & .entry {
                        width:100%;
                        max-width:500px;
                        border-radius: 10px;
                        background-color: rgba(0,0,0,0.1);
                        padding:20px;
                        margin:5px auto;
                        box-sizing: border-box;
                    }
                }
                & .continue {
                    margin:20px;
                    & button {
                        font-size:20px;
                        padding:10px;
                    }
                }
            }
        }
        &.small {
            & .innerdialog {               
                left:30%;
                right:30%;
            }
        }
    }

    .cookieconsent {
        width: calc(100% - 40px);
        position: fixed;
        bottom: 0px;
        padding: 10px 20px;
        //background-color: rgba(255, 0, 0, 0.75);
        background-color: var(--button-color);
        color: white;
        z-index: 100;
        display: flex;
        & .left {
            width: 100%;
            & .title {
                text-align: left;
                font-size: 1.2em;
                margin-bottom: 10px;
                text-transform:uppercase;
            }
            & .subtitle {
                text-align: left;
                margin-bottom: 10px;
            }
        }
        & .footer {
            flex:0 0 auto;
            @include flex();
            justify-content:flex-end;
            align-items:center;
            & .moreinfo {
                background-color:transparent;
                color:white;
                box-shadow: none;
            }
            & .acceptcookies {
                padding:10px;
                background-color:white;
                font-size:1.2em;
                font-weight:bold;
                color:black;
                text-transform: uppercase;
            }
        }
    }

    .notification {
        width: calc(100% - 40px);
        position: fixed;
        left:20px;
        bottom: 20px;
        padding: 20px;
        z-index: 101;
        display: flex;
        box-sizing: border-box;
        align-items: flex-end;
        & .message {
            width:100%;
            text-align: left;
            padding-right: 10px;
        }
        & button {
            flex:0 0 auto;
            padding:10px;
        }
    }

    .mr5 {
        margin-right: 5px;
    }

    @media only screen and (max-width: 1600px) {
        .dialog {
            & .innerdialog {
                left:20%;
                right:20%;
                & > .inner {
                }
            }
        }
    }

    @media only screen and (max-width: 1366px) {
        #nav {
            & a {
                &.user.large {
                }
            }
            & .basketbutton {
                & .bubble {
                }
            }
            & .fnb {
                font-size: 1.2em;
            }
        }
        #logo {
            & img {
            }
        }
        #content {
            & .page {
            }
            &.contact,&.book {
                //height: auto;
                & .page {
                    height: auto;
                    display: block;
                }
            }
        }
    }


    @media only screen and (max-width: 1230px) {
        #nav {
            height:40px;
            & a {
                padding:10px;
                font-size:1.2em;
                &.user.large {
                    // width:40px;
                    // font-size:1.2em;
                    // box-sizing: border-box;
                }
                &.user {
                    & .img {
                        width:30px;
                        height:30px;
                    }
                    & div {
                        width: 30px;
                        height: 30px;
                    }

                }
            }
            & .basketbutton {
                width:40px;
                font-size: 1.2em;
                & .bubble {
                    font-size: 12px;
                    top:0;
                    right:0;
                    width:16px;
                    height: 16px;
                }
            }
            & .fnb {
                width:40px;
                font-size: 1.2em;
            }
            & .user {
                font-size: 30px;
                & .img {
                    width:30px;
                    height:30px;
                }
                &.large {
                    //margin-left:20px;
                    padding:6px!important;
                }
            }
        }
        #logo {
            & img {
                height: auto;
                width: auto;
                max-height: 40px;
                max-width: 200px;
            }
        }
        #app {
            &.header {
                & #content {
                    & .page {
                        margin-top:40px;
                        height:calc(100% - 40px);
                    }
                }
            }
        }
    }


    @media only screen and (max-width: 1024px) {
        // #nav {
        //     height:40px;
        //     & a {
        //         padding:10px;
        //         font-size:1.2em;
        //         &.user.large {
        //             // width:40px;
        //             // font-size:1.2em;
        //             // box-sizing: border-box;
        //         }
        //         &.user {
        //             & .img {
        //                 width:30px;
        //                 height:30px;
        //             }
        //             & div {
        //                 width: 30px;
        //                 height: 30px;
        //             }
        //
        //         }
        //     }
        //     & .basketbutton {
        //         width:40px;
        //         font-size: 1.2em;
        //         & .bubble {
        //             font-size: 12px;
        //             top:0;
        //             right:0;
        //             width:16px;
        //             height: 16px;
        //         }
        //     }
        //     & .fnb {
        //         width:40px;
        //         font-size: 1.2em;
        //     }
        // }
        // #logo {
        //     & img {
        //         height: auto;
        //         width: auto;
        //         max-height: 40px;
        //         max-width: 200px;
        //     }
        // }
        #content {
            & .page {
                margin-top:0;
                height:calc(100% - 0);
            }
            &.contact {
                //height: auto;
                & .page {
                    display: block;
                }
            }
        }

        // .user {
        //     & .img {
        //         width:30px;
        //         height:30px;
        //     }
        //     &.large {
        //         //margin-left:20px;
        //         padding:6px!important;
        //     }
        // }
        .dialog {
            & .innerdialog {
                left:10%;
                right:10%;
                & > .inner {
                }
            }
            &.small {
                & .innerdialog {               
                    left:20%;
                    right:20%;
                }
            }
        }
    }

    @media only screen and (max-width: 768px) {
        #nav {
            ///height:40px;
            & a {
                //padding:10px;
                //font-size:1.2em;
            }
        }
        #content {
            & .page {
                //margin-top:47px;
                //height:calc(100% - 47px);
            }
        }
        .dialog {
            & .innerdialog {
                left:0%;
                right:0%;
                & .closebutton {
                    right:0;
                }
            }
        }
        .notification {
            width: calc(100% - 20px);
            left:10px;
            bottom: 10px;
            padding: 10px;
            & .message {
            }
            & button {
                padding:5px;
            }
        }
    }

    @media only screen and (max-width: 640px) {
        .dialog {
            & .innerdialog {
                & > .inner {
                    flex-wrap: wrap;
                    & .imagewrapper {
                        height:200px;
                        width:100%;
                    }
                    & .rightside {
                        width:100%;
                    }
                }
                & .closebutton {
                }
            }
        }
        .notification {
            & .message {
                font-size: 12px;
            }
            & button {
            }
        }
    }

    @media only screen and (max-width: 450px) {
        .notification {
            bottom:0;
            right:0;
            left:0;
            width:100%;
            & .message {
            }
            & button {
            }
        }
    }


    @media only screen and (max-height: 1024px) and (max-width: 640px) {
        .dialog {
            & .innerdialog {
                top:50px;
                max-height: calc(100% - 50px);
            }
        }
    }


</style>
